
import { useForm, ValidationError } from '@formspree/react';
import Swal from "sweetalert2";
import { useEffect, useRef, useState } from "react";
import Aos from "../../components/aos/aos";
const MainContact = () => {


    const changeLoadTxt = () => {
        const name = document.getElementById('name');
        const email = document.getElementById('email');
        const subject = document.getElementById('subject');
        const message = document.getElementById('message');
        console.log(name.value)
        if (name.value && email.value && subject.value && message.value !== null) {
            Swal.fire({
                icon: 'success',
                title: 'success',
                text: 'Message sent successfully'
            });
            setTimeout(() => {
                elemRef.current.reset()
            }, 2000)
        }
        else if (name.value | email.value | subject.value | message.value === null) {
            Swal.fire({
                icon: 'info',

                text: 'empty field(s)!'
            });
        }
    }
    const elemRef = useRef(null)
    const [state, handleSubmit] = useForm("xknllenq");
    if (state.succeeded) {



    };

    useEffect(() => {
        Aos(1000)
    })
    return (
        <div className="w-full flex flex-col justify-center items-center py-4 px-2 mt-4 rounded-lg bg-white/30 backdrop-blur">

            <div className="w-full md:w-[350px] h-[400px] rounded-lg shadow-lg shadow-gray-500">

                <form data-aos="fade-up" ref={elemRef} onSubmit={handleSubmit} method="POST" className=" font-mono bg-black/50 w-full h-full rounded-lg py-4 px-2 flex flex-col items-center justify-center space-y-8 ">
                    <input type="text" name="name" id="name" placeholder="Name" required className="bg-transparent outline-none placeholder-gray-400 text-white h-12 w-full border-4 rounded-lg border-gray-500 py-1 px-2 text-center" />
                    <input type="email" name="email" id="email" placeholder="Email" required className="bg-transparent outline-none placeholder-gray-400 text-white h-12 w-full border-4 rounded-lg border-gray-500 py-1 px-2 text-center" />
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                    />
                    <input type="text" name="subject" id="subject" placeholder="Subject" required className="bg-transparent outline-none placeholder-gray-400 text-white h-12 w-full border-4 rounded-lg border-gray-500 py-1 px-2 text-center" />

                    <textarea name="message" id="message" placeholder="Message" required className="bg-transparent outline-none placeholder-gray-400  text-white w-full border-4 rounded-lg border-gray-500 py-1 px-2 text-center" ></textarea>
                    <button onClick={changeLoadTxt} type="submit" disabled={state.submitting} className="bg-yellow-500 text-center text-white font-bold py-2 px-2 w-full rounded-lg">Send Message</button>
                </form>
            </div>
        </div>
    );
}

export default MainContact;